export default "__VITE_ASSET__DUMdaWAI__"